import { HTTP_Request } from "../utils/interceptor";
import { BASE_URL } from "../utils/constant";
import { Endpoints } from "./endpoint";


export const AdRewardService = (query) => {
  // let obj = {
  //   page: 1,
  //   limit: 10,
  //   ,
  // };

  return HTTP_Request.post(
    BASE_URL + Endpoints.rewards.addReward+query
  );
};